import { ILine } from '../../global';
import { captureError, fetchWrapper } from '../../utils/request';
import { endpoint } from './endpoint';

console.log(`starting client api to ${endpoint}`);

export enum SortDirections {
  'asc' = 'asc',
  'desc' = 'desc',
}

export async function fetcher(url): Promise<Array<any>> {
  return fetchWrapper(endpoint + url, {
    method: 'get',
  })
    .then((res) => res.json())
    .catch((err) => {
      captureError(err);
      throw err;
    });
}

export async function manyFetcher(...urls) {
  return Promise.all(urls.map((url) => fetcher(url)));
}

export const submitEmail = (email: string): Promise<any> => {
  return fetchWrapper(endpoint + `/v1/email`, {
    method: 'post',
    body: JSON.stringify({ email }),
  });
};

export const newLine = (
  name: string,
  product: string,
  inventory: number,
  stages?: Array<any>,
): Promise<any> => {
  return fetchWrapper(endpoint + `/v1/lines`, {
    method: 'post',
    body: JSON.stringify({ name, product, inventory, stages }),
  }).then((res) => res.json());
};

export const editLine = (
  line: string,
  name?: string,
  product?: string,
  inventory?: number,
  application?: string,
  createdByAi: boolean = null,
): Promise<any> => {
  const reqBody = {};
  if (name) reqBody['name'] = name;
  if (product) reqBody['product'] = product;
  if (application) reqBody['financing_application'] = application;
  if (inventory) reqBody['inventory'] = inventory;
  if (createdByAi !== null) reqBody['created_by_ai'] = createdByAi;
  return fetchWrapper(endpoint + `/v1/lines/v2/${line}`, {
    method: 'put',
    body: JSON.stringify(reqBody),
  });
};

export const editStage = (
  id: string,
  line: string,
  name: string,
  start: string,
  amount: number,
  deleted: boolean,
): Promise<any> => {
  return fetchWrapper(endpoint + `/v1/lines/${line}/stages/${id}`, {
    method: 'put',
    body: JSON.stringify({ name, start, amount, deleted }),
  });
};

export const newStage = (
  line: string,
  name: string,
  start: string,
  amount: number,
  deleted: boolean,
  order?: number,
): Promise<any> => {
  return fetchWrapper(endpoint + `/v1/lines/${line}/stages`, {
    method: 'post',
    body: JSON.stringify({ name, start, amount, order, deleted }),
  }).then((res) => res.json());
};

export const deleteLine = (line): Promise<any> => {
  return fetchWrapper(endpoint + `/v1/lines/${line}`, {
    method: 'delete',
  });
};

export function getLines(
  lineIds: Array<string> = null,
  applicationId: string = null,
): Promise<Array<ILine>> {
  let query = '';
  if (lineIds) {
    query = `?lineIds=${lineIds.join()}`;
  }
  if (applicationId) {
    let start = query ? '&' : '?';
    query = start + `application=${applicationId}`;
  }
  return fetchWrapper(endpoint + `/v1/lines${query}`, {
    method: 'get',
  }).then((res) => res.json());
}

export function uploadFile(line: string, file: any): Promise<any> {
  const data = new FormData();
  data.append('file', file);
  return fetchWrapper(endpoint + `/v1/lines/${line}/documents`, {
    method: 'post',
    body: data,
  }).catch(captureError);
}

export function getBankAccounts(): Promise<any> {
  return fetchWrapper(endpoint + `/v1/bank-account`, {
    method: 'get',
  }).then((res) => res.json());
}

export function deleteBankAccount(id: string): Promise<any> {
  return fetchWrapper(endpoint + `/v1/bank-account/${id}`, {
    method: 'delete',
  }).catch((err) => {
    captureError(err);
    throw err;
  });
}
